/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Grower_Area_Public_Load_Error_DescInputs */

const vi_grower_area_public_load_error_desc = /** @type {(inputs: Grower_Area_Public_Load_Error_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vui lòng kiểm tra kết nối mạng rồi thử lại.`)
};

/**

* @param {Grower_Area_Public_Load_Error_DescInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const grower_area_public_load_error_desc = /** @type {((inputs?: Grower_Area_Public_Load_Error_DescInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Grower_Area_Public_Load_Error_DescInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_grower_area_public_load_error_desc(inputs)
});